import Home from '../components/Home'

let routes = {
    path: '/',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/',
          component: Home,
          meta: {
            notification: false
          }
      },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/home.js